/**
 * Mutation to add a category to a seller
 */
const addCategoryToSellerMutation = `
mutation AddCategoryToSeller($sellerId: ID!, $categoryId: ID!) {
  updateMarketplace_seller(
    input: {
      id: $sellerId
      fields: {
        categories: {
          add: [$categoryId]
        }
      }
    }
  ) {
    marketplace_seller {
      objectId
      categories {
        edges {
          node {
            objectId
            name
          }
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default addCategoryToSellerMutation;